import styled, { keyframes } from 'styled-components'

const tileIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(10px);
	}
	to {
		opacity: 1;
		transform: none;
	}
`

export const FilterRow = styled.div`
	display: flex;
	justify-content: flex-start;
	gap: 0.75rem;
	flex-wrap: wrap;
	margin-bottom: 1.25rem;
`

export const FilterSelect = styled.select`
	padding: 0.5625rem 0.875rem;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	font-size: 1rem;
	color: #111827;
	background-color: white;
	cursor: pointer;
	min-width: 220px;
	max-width: 100%;

	&:focus {
		outline: none;
		border-color: #3b82f6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
	}
`

export const IdeasGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
	gap: 1rem;

	@media (max-width: 600px) {
		grid-template-columns: repeat(2, 1fr);
		gap: 0.75rem;
	}

	@media (min-width: 768px) {
		grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
	}

	@media (min-width: 1200px) {
		grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
	}
`

/**
 * Bare tile — no card chrome, just the rounded image with the name below.
 * Tiles fade-rise in with a light stagger ($index caps so late rows don't lag).
 */
export const IdeaTile = styled.button<{ $index?: number }>`
	display: block;
	width: 100%;
	padding: 0;
	border: none;
	background: transparent;
	text-align: left;
	font: inherit;
	cursor: pointer;
	animation: ${tileIn} 0.3s ease-out both;
	animation-delay: ${({ $index = 0 }) => Math.min($index, 11) * 30}ms;

	&:hover img,
	&:focus-visible img {
		transform: scale(1.03);
	}

	@media (prefers-reduced-motion: reduce) {
		animation: none;
	}
`

/** Square rounded image; ideas without a link preview show a centered icon. */
export const IdeaThumbnail = styled.div`
	width: 100%;
	aspect-ratio: 1;
	overflow: hidden;
	border-radius: 12px;
	background: #f3f4f6;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #9ca3af;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		transition: transform 0.2s ease;
	}
`

export const IdeaName = styled.div`
	padding: 0.5rem 0.125rem 0;
	font-size: 0.875rem;
	font-weight: 500;
	color: #374151;
	/* Two lines then ellipsis, like the iOS tile title. */
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
`
